import { Link } from "react-router-dom";

import { SchedaLockup } from "./SchedaLockup";

/**
 * The Scheda brand in the app's top-left, linking home.
 *
 * <p>Renders the real horizontal logo via {@link SchedaLockup} — the same asset
 * as the landing page and the sign-in modal, and the same artwork as
 * {@code app-icon-512.png}. It used to be a hand-drawn placeholder (a blue
 * rounded square with a comic wordmark), which meant the signed-in app was the
 * one surface that did NOT look like the brand. That mattered beyond taste:
 * Google's OAuth verification for the calendar scopes checks the consent-screen
 * logo against what a user actually sees in the product.</p>
 *
 * <p>{@code surface="auto"} because AppNav's background follows the theme; the
 * lockup swaps to the reversed art under {@code .dark} in CSS alone.</p>
 */
export function SchedaLogo({ className = "" }: { className?: string }) {
  return (
    <Link
      to="/"
      aria-label="Scheda, home"
      className={`inline-flex items-center ${className}`}
    >
      {/* alt="" — the link above already carries the accessible name. */}
      <SchedaLockup className="h-7 w-auto" alt="" />
    </Link>
  );
}
